/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'open': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M244.979 280.077L248.147 1024h109.256l-3.168-743.923h131.107L299.607 0 113.872 280.077zm424.841 0L672.988 1024h109.256l-3.168-743.923h131.107L724.448 0 538.713 280.077z"/>'
  }
})
